import React, { useEffect, useState, lazy, Suspense } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./i18n"; // 👈 import this first!
import LogoSplash from "./LogoSplash";



const Home = lazy(() => import("./Home/Home"));


// Preload map
export const preloadMap = {
  "/": () => import("./Home/Home"),

};

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [pathname]);
  return null;
};

function App() {
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  // Initial splash screen loading state
  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  // Preload component when route changes
  useEffect(() => {
    const preloadFunc = preloadMap[location.pathname];
    if (preloadFunc) {
      preloadFunc();
    }
  }, [location.pathname]);

  if (loading) return <LogoSplash />;

  return (
    <>
      <ScrollToTop />
      <Suspense fallback={<LogoSplash />}>
        <Routes>
          <Route path="/" element={<Home />} />
        
        </Routes>
      </Suspense>



    </>
  );
}

export default App;
